var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.32,
    height: 45.816,
    viewBox: "0 0 40.32 45.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1975",
    "data-name": "Rectangle 1975",
    width: 40.32,
    height: 45.816,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    "data-name": "Path 4429",
    d: "M.649,173.895l1.9,8.577.054-.033L.753,173.726Z",
    transform: "translate(-0.595 -159.381)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4430",
    "data-name": "Path 4430",
    d: "M95.895,402.222l8.028-8.441-25.507-.138-7.543,8.406",
    transform: "translate(-65.021 -361.14)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4431",
    "data-name": "Path 4431",
    d: "M157.394,489.773s.7,4.152,7.751,4.206,7.881-4.1,7.881-4.1Z",
    transform: "translate(-144.398 -449.332)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4432",
    "data-name": "Path 4432",
    d: "M1.462,15.393,7.979,1.034l6.752,32.455L7.2,41.813,1.463,15.381",
    transform: "translate(-1.341 -0.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    "data-name": "Path 4433",
    d: "M6.952,41.054l-.009-.044L1.2,14.579h0L7.746.157l.016.07,6.752,32.466-.007.007ZM1.247,14.587,6.975,40.962l7.493-8.285L7.73.3Z",
    transform: "translate(-1.1 -0.144)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 2.352,
    y2: 2.133,
    transform: "translate(30.843 0.042)",
    fill: "none",
    stroke: "#262223",
    strokeMiterlimit: 10,
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4434",
    "data-name": "Path 4434",
    d: "M362.686.651l-3.553,3.2,3.541.418Z",
    transform: "translate(-329.479 -0.597)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4435",
    "data-name": "Path 4435",
    d: "M362.135,3.719l-.027,0-3.588-.423.034-.031L362.148.025V.076Zm-3.514-.458,3.467.409L362.1.129Z",
    transform: "translate(-328.916 -0.023)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    d: "M81.125.649l6.706,32.414,6.6.035s.849,5.24,8.107,5.286,7.732-5.2,7.732-5.2l3.019.016L114.685.649h-7.051l-.051,2.879s-1.019-.929-5.068-.952a8.3,8.3,0,0,0-4.109.949L98.252.649Z",
    transform: "translate(-74.426 -0.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4437",
    "data-name": "Path 4437",
    d: "M101.947,37.988c-2.077-.013-4.938-.488-6.791-2.675A6.14,6.14,0,0,1,93.807,32.7l-6.6-.035-.007-.034L80.477.175H97.7l0,.038.15,2.806a8.62,8.62,0,0,1,4.015-.918h.054c3.487.02,4.73.7,5.025.907L107,.175h7.141l-1.4,32.627-3.022-.016a5.624,5.624,0,0,1-1.16,2.6c-1.7,2.172-4.528,2.612-6.606,2.6m-14.678-5.4,6.6.035.006.034a5.961,5.961,0,0,0,1.339,2.609c1.833,2.161,4.67,2.63,6.73,2.643s4.864-.422,6.544-2.565a5.462,5.462,0,0,0,1.149-2.6l0-.037,3.017.016L114.044.254h-6.962l-.052,2.934-.074-.067c-.351-.318-1.857-.923-5.037-.941h-.053a8.321,8.321,0,0,0-4.03.942l-.065.04L97.615.254H80.584Z",
    transform: "translate(-73.832 -0.161)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4438",
    "data-name": "Path 4438",
    d: "M101.947,37.988c-2.077-.013-4.938-.488-6.791-2.675A6.14,6.14,0,0,1,93.807,32.7l-6.6-.035-.007-.034L80.477.175H97.7l0,.038.15,2.806a8.62,8.62,0,0,1,4.015-.918h.054c3.487.02,4.73.7,5.025.907L107,.175h7.141l-1.4,32.627-3.022-.016a5.624,5.624,0,0,1-1.16,2.6C106.854,37.561,104.024,38,101.947,37.988Zm-14.678-5.4,6.6.035.006.034a5.961,5.961,0,0,0,1.339,2.609c1.833,2.161,4.67,2.63,6.73,2.643s4.864-.422,6.544-2.565a5.462,5.462,0,0,0,1.149-2.6l0-.037,3.017.016L114.044.254h-6.962l-.052,2.934-.074-.067c-.351-.318-1.857-.923-5.037-.941h-.053a8.321,8.321,0,0,0-4.03.942l-.065.04L97.615.254H80.584Z",
    transform: "translate(-73.832 -0.161)",
    fill: "none",
    stroke: "#221f1f",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4439",
    "data-name": "Path 4439",
    d: "M119.371,39.091l1.387-21.868h4.087l-3.182,29.089-4.329-.021-5.658-29.07h4.041l3.36,21.868c.023.158.284.159.293,0",
    transform: "translate(-102.456 -15.799)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4440",
    "data-name": "Path 4440",
    d: "M282.017,72.228c-3.3-.018-5.075-2.361-5.14-5.548L276.5,48.187c-.065-3.207,1.78-5.581,5.521-5.579,3.718,0,5.629,2.382,5.562,5.594L287.2,66.725c-.067,3.212-1.865,5.521-5.183,5.5m-1.56-5.289c.009,1.5.523,2.257,1.561,2.262s1.552-.745,1.562-2.248l.123-19.061c.01-1.484-.543-2.216-1.679-2.217-1.136.019-1.689.75-1.68,2.212Z",
    transform: "translate(-253.671 -39.09)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4441",
    "data-name": "Path 4441",
    d: "M422.019,46.45l.768-29.163h3.1l-1.093,29.176Z",
    transform: "translate(-387.172 -15.859)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4442",
    "data-name": "Path 4442",
    d: "M268.667,391.885l1.7-1.628.121.165-1.41,1.3,1.688-.917.106.146-1.381,1.335,1.66-.952.118.162-2.062,1.133-.121-.165,1.329-1.29-1.631.88Z",
    transform: "translate(-246.483 -358.033)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4443",
    "data-name": "Path 4443",
    d: "M286.271,407.836l-.17-.1,1.443-1.87.2.115-.853,2.22-.164-.1.256-.649-.3-.177Zm.763-.52.454-1.125-.721.967Z",
    transform: "translate(-262.477 -372.352)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4444",
    "data-name": "Path 4444",
    d: "M306.659,411.951l-.177-.056.248-.863.06-1.517.194.061-.094,1.242.585-1.089.194.061-.76,1.291Z",
    transform: "translate(-281.175 -375.701)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    "data-name": "Path 4445",
    d: "M331,416.78l.124-2.22-.327-.021.009-.154.841.055-.009.154-.325-.021-.125,2.22Z",
    transform: "translate(-303.482 -380.168)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M345.767,417.125a.356.356,0,0,1-.391-.361l-.069-1.66a.379.379,0,0,1,.757-.03l.064,1.66a.354.354,0,0,1-.361.391m-.006-.156a.183.183,0,0,0,.18-.215l-.067-1.687c-.006-.141-.073-.208-.2-.2s-.183.079-.177.218l.069,1.686a.183.183,0,0,0,.194.2",
    transform: "translate(-316.794 -380.468)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M369.322,414.152l-.636-2.288.183-.053.594,2.141.424-.123.04.147Z",
    transform: "translate(-338.243 -377.808)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M380.178,409.977l-1.026-2.13.171-.086,1.024,2.13Z",
    transform: "translate(-347.845 -374.092)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    d: "M385.617,401.166l-1.155-1.718.143-.129,1.3,1.993-.173.156-1.806-1.536.146-.132Z",
    transform: "translate(-352.222 -366.347)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M395.031,392.215l-2.123-1.007.277-.581.138.065-.194.407.839.4.2-.407.134.063-.2.407.878.417.2-.41.136.065Z",
    transform: "translate(-360.465 -358.373)",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    d: "M348.067,448.971l-3.57,3.961h.057l3.6-4Z",
    transform: "translate(-316.051 -411.865)",
    fill: "#a4a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    d: "M158.812,400.958l6.935-8.531-.034-.029-6.957,8.559Z",
    transform: "translate(-145.647 -359.998)",
    fill: "#a4a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    d: "M242.166,390.8h.054l.065.261.184-.449h-.115Z",
    transform: "translate(-222.17 -358.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M5.825,40.927,0,14.5l.006-.013L6.626.01,6.7.045.088,14.506l5.82,26.4Z",
    transform: "translate(0 -0.01)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 2.377,
    y2: 2.122,
    transform: "translate(30.8 0.032)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1974",
    "data-name": "Rectangle 1974",
    width: 3.186,
    height: 0.084,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 30.773, 2.123)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M78.636,392.984l-7.53,8.367-.02.071.076.009.714-.352L76.327,397l2.308-3.639Z",
    transform: "translate(-65.216 -360.535)",
    fill: "#262223"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoi);
export default __webpack_public_path__ + "static/media/logo-voi.2d315f802e36ddcdfa505463553b9a0a.svg";
export { ForwardRef as ReactComponent };